import { render } from "./BaseTable.vue?vue&type=template&id=969e668c"
import script from "./BaseTable.vue?vue&type=script&lang=js"
export * from "./BaseTable.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__